import React, { useEffect, useState } from "react";
import { Avatar } from "primereact/avatar";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import moment from "moment";
import { Handbook_Status, severity } from "../../helper/enum";
import { SendHandbookNotification, SendEscalateNotification } from "../../helper/mail";
import { toast } from "react-toastify";
import { getAllCognitoUsers } from "../../helper/aws";
import { useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { HandbookAssignee } from "../../models";
import { DataStore } from "aws-amplify";

const processOptions = (options = [], nameKey = "", codeKey = "") => {
  if (options.length <= 0) return [];
  return options.map(option => ({ ...option, name: option[nameKey], code: option[codeKey] }));
};

const EditHandbookAssigneePopup = ({
  assigneeDetails: { employeeDetails, handbookDetails, status, created_date, due_date, id },
  ...props
}) => {
  const [visible, setVisible] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [cognitoUsers, setCognitoUsers] = useState([]);

  const formik = useFormik({
    initialValues: {
      employee: ""
    },
    validate: data => {
      let errors = {};
      return errors;
    },
    onSubmit: data => {
      let errors = "";
    }
  });

  const onClickEscalate = async () => {
    const { handbook_name } = handbookDetails;
    const { employee_name } = employeeDetails;
    const created_dateFormatted = moment(created_date).format("YYYY-MM-DD");
    const due_dateFormatted = moment(due_date).format("YYYY-MM-DD");

    const body = `Employee handbook ${handbook_name} is sent to ${employee_name} on ${created_dateFormatted}, He/She was expected to acknowledge the receipt of the handbook on ${due_dateFormatted}. <br/>Please have a look.<br/> Thanks & Regards`;

    const emailsToSend = [formik.values.employee.email];
    handleStatusChange({ status: Handbook_Status.ESCALATED });
    try {
      await SendEscalateNotification({
        to: emailsToSend,
        subject: "Escalation!",
        body,
        from: "ganesh@edbrix.com"
      });

      toast.success("Escalation sent successfully");
      props.popupstate(false);
    } catch (error) {
      // Handle the error
    }
  };

  const getListOfCognitoUsers = async () => {
    try {
      const data = await getAllCognitoUsers();

      const newRes = data.Users.map(user => {
        const userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
        const userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
        const sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
        return {
          userId: sub,
          name: userName,
          email: userEmail
        };
      });
      const processedRes = processOptions(newRes, "name", "email");
      setCognitoUsers(processedRes);
    } catch (error) {
      // Handle the error
    }
  };

  const onClickResend = async () => {
    const emailsToSend = ["project.c@edbrix.com"];
    try {
      handleStatusChange({ status: Handbook_Status.RESENT });
      const res = await SendHandbookNotification({
        to: emailsToSend,
        subject: "Handbook is available!",
        from: "ganesh@edbrix.com"
      });
      toast.success("Handbook sent successfully");
      props.popupstate(false);
    } catch (error) {
      // debugger;
    }
    // Handle resend button click
  };

  const escalateForm = () => {
    const handleCancel = () => setVisible(false);
    return (
      <>
        <form onSubmit={formik.handleSubmit} className="p-fluid">
          <div className="text-[#101828] text-lg py-2 pt-5 mb-[1rem] font-bold">Escalate Manager</div>
          <div className="text-[#344054] text-xs pb-2 font-medium">Enter Manager's name</div>
          <div className="mb-[1rem]">
            <Dropdown
              value={formik.values.employee}
              id="employee"
              options={cognitoUsers}
              optionLabel="name"
              placeholder="Select Manager"
              name="employee"
              filter
              className="border text-[14px] font-normal bg-white rounded h-[2.75rem] px-[0.75rem] border-[#E4E7EC] w-full"
              style={{ fontSize: "0.875rem", color: "#667085", fontWeight: "400" }}
              onChange={e => {
                formik.setFieldValue("employee", e.value);
              }}
            />
          </div>
          <div className="pt-2 flex gap-2 pb-[-2px] justify-center">
            <button
              className="text-[#2D5BE5] font-normal custmBtn3 border-collapse  border-none text-center bg-none"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              disabled={!formik?.values?.employee?.code}
              className="custmBtn3 rounded-lg text-[#FFFFFF] text-center disabled:bg-gray-400 bg-[#113699]"
              onClick={onClickEscalate}
            >
              Confirm
            </button>
          </div>
        </form>
      </>
    );
  };

  const resendForm = () => {
    const handleOK = () => {
      setVisible(false);
      onClickResend();
    };

    return (
      <>
        <div className="text-[#101828] text-lg py-2 pt-5 mb-[1rem] font-bold">Handbook Resent! </div>
        <div className="text-[#344054] text-[1rem] text-xs pb-2 mb-[1rem] font-medium">
          Handbook Reset for {employeeDetails?.employee_name}
        </div>
        <div className="pt-2 flex gap-2 pb-[-2px] justify-center">
          <button
            className="font-normal text-center border-collapse border-none rounded-xl custmBtn3 bg-none"
            onClick={handleOK}
          >
            OK
          </button>
        </div>
      </>
    );
  };

  const handleStatusChange = async ({ status }) => {
    try {
      const original = await DataStore.query(HandbookAssignee, id);

      const res = await DataStore.save(
        HandbookAssignee.copyOf(original, updated => {
          updated.status = status;
        })
      );

      if (res) {
      }
    } catch (error) {
      console.log(error);
    } finally {
      // console.log(error);
    }
  };
  useEffect(() => {
    getListOfCognitoUsers();
  }, []);

  const handleCloseDialog = () => setVisible(false);
  const handleOpenDialog = type => {
    setPopupType(type);
    setVisible(true);
  };

  return (
    <div>
      <div className="bg-[#F5F6F7] p-5">
        <div className="pb-4">
          <button onClick={props.popupstate}>
            <i className="text-black gusd-close-sidebar" style={{ fontSize: 20 }}></i>
          </button>
        </div>
        <div className="pb-4 text-[#113699]">Preview</div>
        <div className="flex flex-col gap-[1rem] rounded-[0.5rem] items-center p-[1rem] bg-white custIcons custmBtnTable custTable">
          <Avatar
            image="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50"
            size="large"
            shape="circle"
          />
          <div>{employeeDetails?.employee_name}</div>
          <div>{employeeDetails?.employee_code}</div>
          <Tag value={status} severity={severity[status]} />
        </div>
        <div className="mt-[1rem]">
          <div className="flex flex-col mb-[1rem]">
            <label className="text-[#344054] text-[0.75rem] pb-1">HandBook Name</label>
            <div className="flex items-center text-[0.875rem] border h-[2.75rem] px-[0.75rem]">
              {handbookDetails?.handbook_name}
            </div>
          </div>
          <div className="flex flex-col">
            <label className="text-[#344054] text-[0.75rem] pb-1">Date HandBook Sent</label>
            <div className="flex items-center text-[0.875rem] border h-[2.75rem] px-[0.75rem]">
              {moment(handbookDetails?.created_date).format("MM/DD/YYYY")}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-3 sm:grid-cols-2 justify-center justify-between my-2 px-2 xl:my-[2.083vw] pt-20 gap-4">
          <button
            onClick={() => {
              handleStatusChange({ status: Handbook_Status.CANCELLED });
              props.popupstate();
            }}
            className="custmBtn2 border text-[#D92D20] rounded-lg text-center bg-[#FEE4E2] hover:bg-[#ffc4bf]"
          >
            <i className="gusd-close text-[14px] pr-3"></i>Cancel
          </button>
          <button
            className="items-center text-center rounded-lg custmBtn2 bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] text-[#344054]"
            onClick={() => handleOpenDialog("escalate")}
          >
            <i className="gusd-user pr-3 text-[12px]"></i>
            Escalate
          </button>
          <button
            className="custmBtn2  rounded-lg  blue text-center"
            onClick={() => handleOpenDialog("resend")}
          >
            <i className="gusd-check pr-3 text-[14px]"></i>Resend
          </button>
        </div>
      </div>
      <div className="flex dialogpoput justify-content-center">
        <Dialog
          visible={visible}
          position="right"
          style={{ width: "32vw" }}
          className="dialogpoput dialogres"
          onHide={handleCloseDialog}
          ariaCloseIconLabel="Close"
          closeOnEscape
        >
          {popupType === "escalate" ? escalateForm() : resendForm()}
        </Dialog>
      </div>
    </div>
  );
};

export default EditHandbookAssigneePopup;
